import React from 'react'
import PropTypes from 'prop-types'

//@MUI
import Button from '@mui/material/Button'
import Slide from '@mui/material/Slide'
import Stack from '@mui/material/Stack'
import Save from '@mui/icons-material/Save'
import { Paper, Typography } from '@mui/material'

const UnsavedChanges = ({
  changesPresent,
  handleSave,
  handleReset,
  title,
  saveButtonText,
  saveIcon,
}) => {
  return (
    <Slide direction="up" in={changesPresent} mountOnEnter unmountOnExit>
      <Stack
        sx={{
          position: 'sticky',
          bottom: 30,
          mt: 2,
          backgroundColor: 'primary.main',
          color: '#fff',

          padding: 2,
          borderRadius: 2,
          border: 'solid 4px',
          borderColor: 'contrast.main',
        }}
        direction={{ xs: 'column', lg: 'row' }}
        component={Paper}
        justifyContent="space-between"
        alignItems="center"
        zIndex={100}
        rowGap={1}
      >
        <Typography
          fontFamily="poppins"
          color="inherit"
          textAlign="center"
          fontSize="1rem"
        >
          {title ?? 'YOU HAVE UNSAVED CHANGES'}
        </Typography>
        <Stack direction="row" gap={1}>
          <Button
            onClick={() => {
              window.location.reload()
            }}
            variant="outlined"
            sx={{
              borderColor: 'contrast.main',
              backgroundColor: '#fff',
              color: 'contrast.main',
            }}
          >
            Reset
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            // sx={{color: 'white', borderColor: 'white'}}
            color="contrast"
            startIcon={saveIcon ?? <Save />}
          >
            {saveButtonText ?? 'Save Changes'}
          </Button>
        </Stack>
      </Stack>
    </Slide>
  )
}

UnsavedChanges.propTypes = {
  changesPresent: PropTypes.bool.isRequired,
  handleSave: PropTypes.func.isRequired,
}

export default UnsavedChanges
